import { BaseService } from '@services/BaseService'

const resource = 'hr/lab'

class LabService extends BaseService {
  constructor() {
    super(resource)
  }
}

export const labService = new LabService()
